module.exports = __webpack_public_path__ + "cement/img/1(4).84d86e05.png";